import { useReCaptcha } from 'vue-recaptcha-v3';

export const useGoogleRecaptcha = () => {
  const recaptchaInstance = useReCaptcha();

  const executeRecaptcha = async (action: string) => {
    await recaptchaInstance?.recaptchaLoaded();

    const recaptchaToken = await recaptchaInstance?.executeRecaptcha(action);

    const recaptchaData = {
      'g-recaptcha-response': recaptchaToken ?? null
    };

    const recaptchaHeaders = {
      headers: {
        'google-recaptcha-token': recaptchaToken
      }
    };

    return { recaptchaToken, recaptchaHeaders, recaptchaData };
  };

  return {
    executeRecaptcha
  };
};
